// 下载-样式属性
export const StyleEnum = Object.freeze({
  BUTTON: 'button', // 按钮
  LINK: 'link', // 链接
});

// 下载-类型
export const DownloadTypeEnum = Object.freeze({
  LINK: 'fileLink', // 文件下载链接
  BLOB: 'fileBlob', // 接口请求返回文件流
  INFO: 'fileInfo', // 接口请求返回数据，后续通过回调自行使用
});

// 下载-链接打开位置属性
export const TargetEnum = Object.freeze({
  SELF: '_self', // 本窗口（默认）
  BLANK: '_blank', // 新窗口
  PARENT: '_parent', // 父窗口
  TOP: '_top', // 最初窗口
});

/**
 * 下载文件——转换文件流
 * @param {*} param
 */
export const transformBlobToFile = response => {
  const { headers, data } = response;
  let filename = '未知文件';
  try {
    filename = headers['content-disposition'].split('filename=')[1];
  } catch (error) {}
  filename = decodeURIComponent(filename);
  if ('download' in document.createElement('a')) {
    // 非IE下载
    const eLink = document.createElement('a');
    eLink.download = filename;
    eLink.style.display = 'none';
    eLink.href = URL.createObjectURL(new Blob([data]));
    document.body.appendChild(eLink);
    eLink.click();
    URL.revokeObjectURL(eLink.href); // 释放URL 对象
    document.body.removeChild(eLink);
  } else {
    // IE10+下载
    navigator.msSaveBlob(data, filename);
  }
};
